import { styled, Box, Theme, CSSObject } from '@mui/material';
import { rem, Bold } from '@core-web/typography';

export const MenuIconWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: rem(12),
  borderRadius: rem(4),
  '&:hover': {
    backgroundColor: palette.colors.grey_100,
    ' svg path': {
      fill: palette.colors.blue_700,
    },
  },
  '&.active': {
    backgroundColor: palette.colors.grey_100,
    ' svg path': {
      fill: palette.colors.blue_700,
    },
  },
  '&.visible': {
    ' .menuIcon': {
      display: 'none',
    },
    ' .menuIconTitleWrapper': {
      display: 'flex',
    },
  },
}));

export const MenuIconContainer = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: 0,
  padding: 0,
}));

export const MenuIcon = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  position: 'relative',
  transition: 'all 0.5s ease-in',
}));

export const MenuIconStyle = {
  width: rem(24),
  height: rem(24),
  display: 'flex',
};

export const MenuIconTitle = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  fontSize: rem(12),
  fontWeight: Bold._500,
  lineHeight: rem(18),
  whiteSpace: 'nowrap',
  padding: `${rem(5)} 0`,
}));

export const MenuIconTitleWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'none',
}));

const CommonStyle = (theme: Theme): CSSObject => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: rem(20),
  height: rem(20),
  borderRadius: '50%',
  backgroundColor: theme.palette.colors.orange,
  left: '50%',
  bottom: '50%',
  color: theme.palette.colors.white,
  textAlign: 'center',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontSize: rem(12),
  fontWeight: Bold._500,
  letterSpacing: '-0.2px',
});

export const IconBadge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  ...CommonStyle(theme),
}));

export const IconTitleBadge = styled('span')(({ theme }) => ({
  marginLeft: rem(4),
  ...CommonStyle(theme),
}));
